import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAreasApi,
  addAreaApi,
  updateAreaApi,
  deleteAreaApi,
} from "../services/AreaService";

// Fetch all areas
export const fetchAreas = createAsyncThunk(
  "areas/fetchAreas",
  async (searchText = "") => {
    const response = await fetchAreasApi(searchText);
    return response;
  }
);

// Add new area
export const addArea = createAsyncThunk("areas/addArea", async (areaData) => {
  const response = await addAreaApi(areaData);
  if (response.head.code === 200) {
    return response.head.msg;
  } else {
    throw new Error(response.head.msg);
  }
});

// Update area
export const updateArea = createAsyncThunk(
  "areas/updateArea",
  async (areaData) => {
    const response = await updateAreaApi(areaData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Delete area
export const deleteArea = createAsyncThunk(
  "areas/deleteArea",
  async ({ areaId, currentUserId }) => {
    const response = await deleteAreaApi(areaId, currentUserId);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

const areaSlice = createSlice({
  name: "areas",
  initialState: {
    areas: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAreas.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAreas.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.areas = action.payload;
      })
      .addCase(fetchAreas.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addArea.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addArea.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addArea.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateArea.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateArea.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateArea.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteArea.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteArea.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteArea.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default areaSlice.reducer;
